module.exports = "메인화면"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/main/main.component.html
// module id = ./src/app/components/main/main.component.html
// module chunks = 1